// Fontes auto-hospedadas: o painel não depende do Google para abrir com a
// cara certa — na obra, a internet que falta pode ser justamente a externa.
// Os pesos importados são exatamente os que o CSS usa (ADR-011).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ApiRequestError } from '@/lib/errors';
import { AuthProvider } from '@/lib/auth';
import { router } from '@/router';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Erro de permissão ou de validação não melhora com nova tentativa.
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError && !error.isRetryable) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado no index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
